import { CCTM, CCTM_demo, CCTM_item, CCTM_link, CCTM_route, CCTM_subnav, Link, useCCTM, useModel } from "@bcm-dev/bcms-vite";
import Util from 'classes/Util';
import { ContentHeaderView, WidgetContainer } from 'components/shared';
import React from 'react';
import { SVGAsset } from 'res';
import './styles.css';
/**
 * @function QuickLinksWidget
 * @param {String} className - Allows us to set a custom class name for the component
 * @return {React.Component}
 * @exported true
 * @description The widget that shows Credit Sense in a iframe
 */

 export default function QuickLinksWidget(props){
  const { demos } = useModel();
  const xml =  useCCTM(),
       page = <CCTM nav-id={"quickLinks"} xml={xml} self={Wrapper}>                                          
                <CCTM_route component={QuickLink}/>                  
                <CCTM_link component={QuickLink}/> 
                <CCTM_item component={QuickLink}/>                               
                <CCTM_demo component={QuickLink} demos={demos}/>     
                <CCTM_subnav component={QuickLinksSubnav}/>                  
         </CCTM>
 
 
  return(
  <div className={(props["custom-class"]?props["custom-class"]:"") + " quick-links-widget-container"}>
   {page}
   </div>
  );
}
function QuickLinksSubnav(props){
  const { demos } = useModel();

  const page = <CCTM  xml={props.currentNode} self={QuickLinkContainer} data={props.data}>                                          
                <CCTM_route component={QuickLink}/>                  
                <CCTM_link component={QuickLink}/> 
                <CCTM_item component={QuickLink}/>                               
                <CCTM_demo component={QuickLink} demos={demos}/>     
                <CCTM_subnav component={QuickLinksSubnav}/>                  
         </CCTM>
 
 
  return(
    
     page

  );
}

function Wrapper(props){

  return<>
  {props.children}
  </>
   
   
}


/**
 * @function QuickLinkContainer
 * @param {String} className - Allows us to set a custom class name for the component
 * @return {React.Component}
 * @exported true
 * @description The widget that shows Credit Sense in a iframe
 */

 export function QuickLinkContainer(props){
  const checkHasAsset = (children) => {
    return React.Children.toArray(children).some(child => {
      if (!React.isValidElement(child)) return false;  
     
      if ("asset_name" in child.props) return true;
  
      
      return checkHasAsset(child.props.children);
    });
  };
  let datapoint = props.datapoint? {dataPoint:props.datapoint}:{dataPoint:"quick-links-_Header"};
  const childHasAsset =checkHasAsset(props.children);
   return (
     <WidgetContainer className={"quick-links-widget"+(childHasAsset?" img-quick-link-widget":"")}>
       <ContentHeaderView text={props.label} {...datapoint} className={Util.inMabi ? "mabi-quicklinks-header" : "abi-quicklinks-header"} />
       {props.children}
     </WidgetContainer>)
 }

/**
 * @function QuickLink
 * @param {String} className - Allows us to set a custom class name for the component
 * @return {React.Component}
 * @exported true
 * @description The widget that shows Credit Sense in a iframe
 */

 export function QuickLink(props){
  let to = props.onClick?undefined:props.to ;
  let datapoint = props.datapoint? {dataPoint:props.datapoint}:{};
  const customClassForIcon = props["asset_custom-class"] ? { className: props["asset_custom-class"] } : { };
  return <div className={(Util.inMabi?"mabi-quicklink ":"abi-quicklink ")+("quickLink_wrapper quick-link flex-container flex-horizontal align-center "+(props.asset_name?" has-icon ":"") +(props["custom-class"]?? ""))} >
    {props.asset_name ? <SVGAsset id={props.asset_name} {...customClassForIcon}/>:<></>}
    <Link onClick={props.onClick} to={to} {...datapoint} className={'clickable quickLink_label ' +(props["custom-class"]?props["custom-class"]:"")} >{props.label}</Link>
    
    </div> 
    
 }